export default __webpack_public_path__ + "static/media/preregister.7903dc57.mp4";